const headingCls = "oaeh10imqwp";
const textCls = "oaet17rdr12";
const buttonWrapperCls = "oaeb1pg1b3";
const buttonCls = "oaeb1khd46g";

export { buttonCls, buttonWrapperCls, headingCls, textCls };
import "./message.base.style.linaria.module.css";
//# sourceMappingURL=message.base.style.js.map
